import { object, string, InferType } from "yup";
import CodeField from "@/components/form/CodeField";
import InputField from "@/components/form/InputField";

export const sendACommandValidationSchema = object({
  parameters: object().shape({
    queue_name: string().required("Queue Name is required"),
    payload: string().required("Payload is required"),
  }),
});

export type SendACommandFormValues = InferType<
  typeof sendACommandValidationSchema
>;

export default function SendACommandFields() {
  return (
    <div>
      <InputField name="parameters.queue_name" label="Queue Name" required />

      <CodeField
        name="parameters.payload"
        label="Payload"
        language="application/json"
        required
      />
    </div>
  );
}
